import React from 'react';
import styled from 'styled-components';
import Card from 'components/common/Card';

export const Container = styled.div`
  display: flex;
  justify-content: center;
`;

export const InnerContain = styled.div`
  flex: 1;
  max-width: 1600px;
  margin-top: calc(88px + 40px);

  ${(props) => props.theme.media.sm.max`
    width: 100%;
    margin-top: 0px !important;
    padding-left: 0px !important;
    padding-right: 0px !important;
  `}

  ${(props) => props.theme.media.xl.max`
    max-width: 1366px;
    margin-top: calc(88px + 24px);
  `}

  ${(props) => props.theme.media.sm.min`
    padding-left: 16px;
    padding-right: 16px;
  `}

  ${(props) => props.theme.media.lg.max`
    max-width: 1024px;
  `}
`;

export const Required = styled.span`
  font-weight: 400;
  font-size: 1.2em;
  position: relative;
  left: 2px;
  color: #F44336;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0px -8px;
  flex-direction: row;
  align-items: flex-start;
`;

export const FlexItem = styled.div`
  margin: 0px 8px;
  flex: ${(props) => props.flex || 1};
  min-width: ${(props) => props.maxWidth ? `${props.maxWidth}px` : '200px'};
  max-width: ${(props) => props.maxWidth && `${props.maxWidth}px`};
  margin-right: ${(props) => props.marginRight && `${props.marginRight}px`};
`;

export const StepTitle = styled(Card.Title)`
  font-size: 1.5em;
`;

export const FormContainer = styled.div`
  background-color: #f5f6f7;
  padding: 1em;
  border-radius: 4px;
  margin-bottom: 0.5em;

  ${props => props.secondary && `
    background-color: unset;
    box-shadow: inset 0px 0px 0px 1px #f5f6f7;
  `}
`;

export const ButtonsContain = styled.div`
  display: flex;
  height: 48px;
  align-items: center;
  justify-content: space-between;
  ${(props) =>
    props.justifyEnd &&
    `
    justify-content: flex-end !important;
  `}
`;

export const Button = styled.div`
  display: inline-flex;
  color: #fff;
  font-weight: 500;
  border-radius: 4px;
  cursor: pointer;
  min-width: 120px;
  padding: 0rem 0.5rem;
  line-height: 2.8em;
  justify-content: center;
  font-family: 'Roboto';
  background-color: ${(props) => props.theme.brandColor};

  ${(props) =>
    props.removeTopRadius &&
    `
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
  `}

  ${(props) =>
    props.disabled &&
    `
    color: #a4a4a4;
    background-color: #e5e5e5;
  `}

  ${(props) =>
    props.secondary &&
    `
    background-color: #fff;
    color: rgb(20, 76, 110);
    box-shadow: inset 0px 0px 0px 2px rgb(20, 76, 110);
  `}

  ${props => props.inline && `
    display: inline-flex;
    max-width: none;
    padding-left: 1em;
    padding-right: 1em;
  `}

  transition: all 0.15s ease-in-out;

  &:hover {
    opacity: 0.8 !important;
  }

  &:active {
    opacity: 0.5 !important;
  }
`;

export const ContentContain = styled.div`
  margin: 16px;
`;

export const StepInformation = styled.p`
  font-family: 'Roboto';
  line-height: ${props => props.lineHeight || '2em'};;
  color: #333;
  margin-top: 0.5em;
  margin-bottom: 01em;
  font-weight: 300;
`;

export const LoadingContain = styled.div`
  display: flex;
  font-family: 'Roboto';
  font-size: 1.1em;
  line-height: 2em;
  color: ${(props) => props.theme.brandColor};
  margin-top: 0.5em;
  margin-bottom: 01em;
  font-weight: 500;

  ${(props) => props.justify && `
    flex: 1;
    justify-content: ${props.justify};
  `};
`;

export const MarginBottom = styled.div`
  margin-bottom: ${(props) => props.margin || 1}em};
`;

export const Divider = styled.div`
  border-style: solid;
  border-color: #c7d7e1;
  border-width: 0px 0px 1px 0px;
  margin-top: 1em;
  margin-bottom: 1em;
`;

export const StepSubTitle = styled(Card.Title)`
  background-color: #c7d7e11f;
  padding-left: 1em;
  font-size: 1em;
  color: #1d5f87;
  line-height: 2em;
  margin-bottom: 1.25em;
  border-radius: 2px;
  margin-top: 1.25em;
  font-weight: 400;
  box-shadow: 0px 0px 0px 1px #c7d7e166;
`;

export const CertContain = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
  border-radius: 2px;
  background-color: #fff;
  box-shadow: 0px 1px 0px 0px #144c6e33;
  margin-bottom: 2px;
  border-radius: 2px;
  line-height: 2.5em;
  cursor: ${(props) => (props.summary ? 'initial' : 'pointer')};
  border-color: #01345312;
  padding: 0.5em;
  padding-top: 1em;
  padding-right: 1.5em;
  border-width: 0px 0px 4px 0px;

  ${(props) =>
    props.hideBorder &&
    `
    box-shadow: none !important
  `}

  &:hover {
    ${(props) =>
      !props.selected &&
      !props.disableHover &&
      !props.summary &&
      `
      box-shadow: 0px 0px 0px 2px ${props.theme.brandColor} !important;
    `}
  }

  ${(props) =>
    props.selected &&
    `
    border-color: #fff;
    box-shadow: 0px 0px 0px 2px rgb(67, 170, 172) !important;
  `}

  ${(props) =>
    props.removePadding &&
    `
    padding: 0px;
    padding-top: 0px;
    padding-right: 0px;
    margin-right: 24px;
  `}
`;

export const CertTitle = styled.div`
  font-family: Roboto;
  font-weight: 500;
  font-size: 1.1em;
  color: ${(props) => props.color || (props.urgent ? 'rgb(213, 138, 34)' : props.theme.brandColor)};
`;

export const CertPrice = styled.div`
  font-size: 1.2em;
  font-family: Roboto;
  font-weight: 500;
  color: #333;
`;

export const CertDescription = styled.div`
  font-size: 0.875em;
  font-color: #333;
  font-family: Roboto;
  font-weight: 300;
  color: #333;
  line-height: 1em;
  padding-bottom: 1em;
`;

export const FlexContain = styled.div`
  display: flex;
  margin: 0px -8px;
`;

export const DividerContain = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  padding: 8px;
`;

export const DividerText = styled.p`
  margin: 0px;
  display: flex;
  font-size: 1.2em;
  font-weight: 500;
  font-family: roboto;
  align-items: center;
  color: grey !important;
`;

export const LineItem = styled.div``;

export const LineItemText = styled.p`
  font-size: 1em;
  line-height: 1.2em;
  font-weight: unset;
  color: rgb(1, 52, 83);
  font-family: roboto, sans-serif;

  ${(props) =>
    props.removeMargin &&
    `
    margin: 0px;
  `}

  ${(props) =>
    props.fontSize &&
    `
    font-size: ${props.fontSize}em;
  `}
`;

export const LineItemTitle = styled.p``;

export const IconContain = styled.div`
  margin-left: 0.2em;
  margin-right: 0.5em;
  top: 0.2em;
  display: flex;
  align-items: center;
  position: relative;
`;

export const OrderSummaryCard = styled(Card.Content)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5em;
`;

export const SummaryItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  height: 2em;
  margin-bottom: 1.5em;
  box-shadow: 0px 1px 0px 0px #e9eff3;
  padding-bottom: 0.5em;
`;

export const SummaryText = styled.p`
  margin: 0px;
  font-size: 1em;
  font-family: Roboto;
  font-weight: 500;
  color: ${(props) => props.theme.brandColor};

  ${(props) =>
    props.fontSize &&
    `
    font-size: ${props.fontSize}em;
  `}
`;

export const SummaryLabel = styled.p`
  font-weight: 400;
  color: #495e6aba;
  font-family: Roboto;
  font-size: 0.875em;
  margin: 0em;
  margin-right: 0.5em;
`;

export const CardContain = styled.div`
  display: flex;
  align-items: stretch;
  display: inline-flex;

  padding: 1em 0em;
  border-radius: 2px;
`;

export const CardBrand = styled.img`
  height: 24px;
  margin-right: 8px;
`;

export const CardNumberContain = styled((props) => (
  <div className={props.className}>{props.children}</div>
))`
  display: flex;
  align-items: center;
  padding: 0em 0.3em;
  border-radius: 2px;
  color: #000;
  margin-right: 0.2em;
  height: 24px;
  position: relative;
  background-color: #fff;

  ${(props) =>
    props.placeholder &&
    `
    padding-top: 4px;
    top: -1px;
    letter-spacing: 0.2em;

  `};
`;

export const CardNumber = styled.div`
  font-family: Roboto;
  font-size: 1em;
  display: flex;
  color: #585858;
`;

export const CardExpiry = styled.div`
  font-family: Roboto;
  line-height: 1.5em;
  align-items: center;
  display: inline-flex;
  font-size: 1em;
  margin-left: 1em;
`;

export const CardLabel = styled.div`
  font-family: 'Roboto';
  background-color: #f4f4f4;
  padding: 0.4em 0.8em;
  border-radius: 2px;
  color: #495e6a;
  margin-right: 0.5em;
  font-size: 0.8em;
`;

export const ActionsContain = styled.div`
  margin-top: 1em;
`;

export const ErrorListItem = styled.li`
  line-height: 1.5em;
  line-height: 1.5em;
  background-color: #fafafa;
  padding: 0.5em 0.5em;
  margin-bottom: 0.5em;
  border-radius: 2px;
`;

export const ErrorBold = styled.span`
  font-weight: 500;
  color: rgb(1, 52, 83);
`;

export const ErrorListContain = styled.ul`
  padding-left: 1em;
  margin-bottom: 1.5em;
`;

export const SuggestionsContainer = styled.div`
  box-shadow: 0px 0px 0px 1px #c7d7e14a, 0px 2px 4px 0px #0000001f;
  border-radius: 4px;
  position: absolute;
  z-index: 999;
  background-color: #fff;
  width: calc(100%);
  top: calc(100% + 0.2em);
  max-height: 420px;
  overflow: auto;

  ::-webkit-scrollbar {
    width: 12px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: #ccc;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #ccc;
  }
`;

export const Suggestion = styled.div`
  font-family: Roboto;
  cursor: Pointer;
  padding: 1em;
  will-change: background-color;

  &:hover {
    background-color: #c7d7e11f;
  }
`;

export const AddressLookupContain = styled.div`
  position: relative;
`;

export const Notice = styled.div`
  padding: 0.5em;
  color: #d96a00;
  margin-top: 1em;
  line-height: 1.5em;
  text-align: center;
  border-radius: 4px;
  margin-bottom: 1em;
  font-family: Roboto;
  background-color: #f5a63c0f;
  box-shadow: 0px 0px 0px 1px #f5943c94;
`;

export const AddressesContain = styled.div`
  background-color: #c7d7e10f;
  padding: 12px;
  padding-top: 24px;
  border-radius: 4px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  box-shadow: 0px 0px 0px 1px #c7d7e1;

  max-height: 400px;
  overflow: auto;
`;

export const PagesContain = styled.div`
  display: flex;
  flex: 1;
`;

export const ResultsContain = styled.div`
  
`;

export const AddressTitle = styled.p`
  font-weight: 500;
  margin: 0px;
  padding-bottom: 8px;
`;

export const SkipContain = styled.div`
  background-color: #f5f6f7;
  margin-top: 8px;
  padding: 1em;
  box-shadow: 0px 0px 0px 1px #dadada69;
  border-radius: 4px;
`;

export const SkipCard = styled(Card.Content)`
  margin-bottom: 1em;
`;

export const ScrollContainer = styled.div`
  overflow: auto;
  max-height: 65vh;

  ::-webkit-scrollbar {
    width: 12px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: #ccc;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #ccc;
  }
`;

export const Banner = styled.div`
  background-color: #0076be;
  margin-bottom: 0.5em;
  padding: 1em;
  border-radius: 4px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 20px 25px -5px rgba(0,0,0,.1),0 10px 10px -5px rgba(0,0,0,.04)!important;
`;

export const UploadHelpText = styled(CertDescription)`
  padding: 1em;
  padding-bottom: 0em;
  line-height: 1.4em;
  color: #000000ad !important;
`;
